import { render } from "./StatPanel.vue?vue&type=template&id=3816a0f1&scoped=true&ts=true"
import script from "./StatPanel.vue?vue&type=script&lang=ts"
export * from "./StatPanel.vue?vue&type=script&lang=ts"

import "./StatPanel.vue?vue&type=style&index=0&id=3816a0f1&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/chronicle/chronicle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3816a0f1"]])

export default __exports__